module.exports = __webpack_public_path__ + "account/img/149.060437b6.png";